module.exports = __webpack_public_path__ + "static/media/cart.08beb7de.jpeg";